import { render, staticRenderFns } from "./appconfig.vue?vue&type=template&id=bad61c46&scoped=true"
import script from "./appconfig.vue?vue&type=script&lang=js"
export * from "./appconfig.vue?vue&type=script&lang=js"
import style0 from "./appconfig.vue?vue&type=style&index=0&id=bad61c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad61c46",
  null
  
)

export default component.exports